import VirtualRoulette_Images from 'IMAXAVirtualRoulette/Assets/Graphics/**/*.png';
import VirtualRoulette_Json from 'IMAXAVirtualRoulette/Assets/**/*.json';
import BaseRoulette_Json from 'BaseRoulette/Assets/**/*.json';
import BaseRoulette_Images from 'BaseRoulette/Assets/Graphics/**/*.png';
import Core_Images from 'Core/Assets/Graphics/**/*.png';
import Core_Xml from 'Core/Assets/**/*.xml';
import { Client } from "@core/Client";

import { Constants } from "@core/Utils/Constants";
import BaseRouletteLoadGame from 'BaseRoulette/Sources/Scenes/LoadGame';

export class IMAXAVirtualRouletteLoadGame extends BaseRouletteLoadGame {
	constructor() {
		super();
		this.gameName = "IMAXA VIRTUAL ROULETTE";
	}

	override LoadGraphics(): void {
		super.LoadGraphics();

		this.load.atlas(Constants.SPRITESHEET, BaseRoulette_Images.SpriteSheet, BaseRoulette_Json.Graphics.SpriteSheet);
		this.load.image("winNumBackground", BaseRoulette_Images.winNumBackground);

		if (Client.logic.setup) {//if by any chance we have setup so quickly, load only specific assets
			if (Client.logic.setup.DoubleZero) {
				this.load.atlas(Constants.SPRITESHEET_TRACK_00, BaseRoulette_Images.Track_00_SpriteSheet, BaseRoulette_Json.Graphics.Track_00_SpriteSheet);
			}
			else {
				this.load.atlas(Constants.SPRITESHEET_TRACK, BaseRoulette_Images.TrackSpriteSheet, BaseRoulette_Json.Graphics.TrackSpriteSheet);
			}
		} else {//else load both single and double zero assets
			this.load.atlas(Constants.SPRITESHEET_TRACK, BaseRoulette_Images.TrackSpriteSheet, BaseRoulette_Json.Graphics.TrackSpriteSheet);
			this.load.atlas(Constants.SPRITESHEET_TRACK_00, BaseRoulette_Images.Track_00_SpriteSheet, BaseRoulette_Json.Graphics.Track_00_SpriteSheet);
		}

		this.load.atlas(Constants.SPRITESHEET_STATISTICS, BaseRoulette_Images.StatisticsAtlas, BaseRoulette_Json.Graphics.StatisticsAtlas);

		this.load.atlas(Constants.ANIMATIONS.COLD_ANIMATION, BaseRoulette_Images.ColdAnimation, BaseRoulette_Json.Graphics.ColdAnimation);
		this.load.atlas(Constants.ANIMATIONS.HOT_ANIMATION, BaseRoulette_Images.HotAnimation, BaseRoulette_Json.Graphics.HotAnimation);

		this.load.atlas(Constants.ANIMATIONS.BALL_END, VirtualRoulette_Images.BallEnd, VirtualRoulette_Json.Graphics.BallEnd);
		this.load.atlas(Constants.ANIMATIONS.BALL_SIM01, VirtualRoulette_Images.BallSim01, VirtualRoulette_Json.Graphics.BallSim01);
		this.load.atlas(Constants.ANIMATIONS.BALL_SIM02, VirtualRoulette_Images.BallSim02, VirtualRoulette_Json.Graphics.BallSim02);
		this.load.atlas(Constants.ANIMATIONS.BALL_SIM03, VirtualRoulette_Images.BallSim03, VirtualRoulette_Json.Graphics.BallSim03);
		this.load.atlas(Constants.ANIMATIONS.BALL_SIM04, VirtualRoulette_Images.BallSim04, VirtualRoulette_Json.Graphics.BallSim04);

		this.load.atlas("historyMisc", BaseRoulette_Images.historyMisc, BaseRoulette_Json.Graphics.historyMisc);
		
		if (this.game.device.os.iOS)
			this.load.image(Constants.IOS_INTRO_GAME_IMAGE, VirtualRoulette_Images.iosVirtualRoulette);

		this.load.atlas(Constants.SPRITESHEET_BALL_DROPPED_ZOOM, VirtualRoulette_Images.Ball_Dropped_Zoom, VirtualRoulette_Json.Graphics.Ball_Dropped_Zoom);
		this.load.atlas(Constants.SPRITESHEET_VIRTUAL_WHEEL, VirtualRoulette_Images.VirtualWheel, VirtualRoulette_Json.Graphics.VirtualWheel);
	}

	override LoadFonts(): void {
		super.LoadFonts();
		this.load.bitmapFont('bodonistd-bold', Core_Images.Fonts["bodonistd-bold"], Core_Xml.Graphics.Fonts["bodonistd-bold"]);
	}
}
